var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "g",
    {
      staticClass: "gantt-elastic__chart-row-progress-bar-wrapper",
      style: {
        ..._vm.root.style["chart-row-progress-bar-wrapper"],
        ..._vm.task.style["chart-row-progress-bar-wrapper"],
      },
    },
    [
      _c("defs", [
        _c(
          "pattern",
          {
            attrs: {
              id: "diagonalHatch",
              width: _vm.root.state.options.chart.progress.width,
              height: _vm.root.state.options.chart.progress.width,
              patternTransform: "rotate(45 0 0)",
              patternUnits: "userSpaceOnUse",
            },
          },
          [
            _c("line", {
              staticClass: "chart-row-progress-bar-line",
              style: {
                ..._vm.root.style["chart-row-progress-bar-line"],
                ..._vm.task.style["chart-row-progress-bar-line"],
              },
              attrs: {
                x1: "0",
                y1: "0",
                x2: "0",
                y2: _vm.root.state.options.chart.progress.width,
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.root.state.options.chart.progress.bar
        ? _c("rect", {
            staticClass: "gantt-elastic__chart-row-progress-bar-solid",
            style: {
              ..._vm.root.style["chart-row-progress-bar-solid"],
              ..._vm.task.style["chart-row-progress-bar-solid"],
            },
            attrs: { x: "0", y: "0", width: _vm.getProgressWidth },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.root.state.options.chart.progress.pattern
        ? _c("g", [
            _c("rect", {
              staticClass: "gantt-elastic__chart-row-progress-bar-pattern",
              style: {
                ..._vm.root.style["chart-row-progress-bar-pattern"],
                ..._vm.task.style["chart-row-progress-bar-pattern"],
              },
              attrs: {
                x: _vm.getProgressWidth,
                y: "0",
                width: 100 - _vm.task.progress + "%",
                height: "100%",
              },
            }),
            _vm._v(" "),
            _c("path", {
              staticClass: "gantt-elastic__chart-row-progress-bar-outline",
              style: {
                ..._vm.root.style["chart-row-progress-bar-outline"],
                ..._vm.task.style["base"],
                ..._vm.task.style["chart-row-progress-bar-outline"],
              },
              attrs: { d: _vm.getLinePoints },
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }